export default [
    {
        label: "Responses",
        icon: "icon-folder",
        show:false, //whether to show this in the edit table 
        tableSettings: {
            route: "caseresponses",
            formType: "sidebarRightSide",
            showItemPerPageOption: true,
            showSelectTable: true,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "", 
            },
            filterEndpoint: "myResponses",
            showAddBtnDefault: true,
            showActionButtonDefault: true, //if this is false the add and edit button will not be shown 
            showEditBtnDefault: true, 
            additionalData: {  
                pkId: "", 
                createdBy: "" // we set this on the fly
            }
        },
    }, 
];